import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Productos from "../components/Productos";

import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import useStore from "../store/useStore";

const productos = [
  {
    title: "Automatización de pagos",
    description:
      "Automatice el pago de gravámenes, con la generación y el pago del VEP en el momento exacto de la nacionalización de la mercadería para evitar la inmovilización de fondos en la cuenta María.",
  },
  {
    title: "Gestión de pagos con códigos QR",
    description:
      "Simplifique la gestión de pagos a terminales portuarias, depósitos fiscales, aeropuertos, trámites de AFIP con un lector de QR vinculado directamente a la cuenta bancaria de la compañía y con permisos diferenciados de pagos para cada usuario.",
  },
  {
    title: "Inversiones más eficientes y menos pérdidas",
    description:
      "Rentabilice diariamente los fondos depositados en la billetera, a través de los únicos prestadores de servicios de pago homologados por BCRA y la única billetera recaudadora de AFIP del comercio exterior.",
  },
  {
    title: "Inversiones más eficientes y menos pérdidas",
    description:
      "Elimina la inmovilización y desvíos de dinero, permitiendo invertir de forma estratégica en mejores oportunidades.",
  },
];

export default function Pay() {
  const { payHeroes, getPayHeroes } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getPayHeroes();
  }, [getPayHeroes]);

  return (
    <div className="bg-sidom-light dark:bg-sidom-blue">
      <Navbar />
      <div>
        {payHeroes?.length === 0 || !payHeroes ? (
          <VideoBackground
            video="/placeholder.mp4"
            titulo1="Cargando..."
            titulo2="Espere un momento"
            textbutton="SOLICITAR DEMO"
            logo="/placeholder-logo.png"
          />
        ) : (
          payHeroes.map((item, index) => (
            <VideoBackground
              key={index}
              video={`${urlApi}${item.video[0]?.url}`}
              titulo1={item.titulo}
              titulo2={item.text}
              textbutton="SOLICITAR DEMO"
              logo={`${urlApi}${
                item.img[0]?.formats?.thumbnail?.url ||
                item.img?.url ||
                "/placeholder-logo.png"
              }`}
            />
          ))
        )}
      </div>
      <section className="text-dark-gray overflow-hidden md:flex md:h-screen py-36 items-center ">
        <div className="container">
          <div className="text-sidom-dark dark:text-sidom-light items-center gap-6">
            <div className="flex flex-col items-center justify-center">
              <h5 className="font-semibold leading-normal text-[20px] mb-6">
                ¿Qué es SIDOM Pay?
              </h5>
              <p className="mb-4">
                La primera billetera virtual que automatiza, centraliza y
                gestiona todos los procesos de pagos de comercio exterior.
                Redefinimos el concepto de los pagos aduaneros al crear el
                primer y único botón de la región que automatiza el proceso en
                su totalidad, co creado junto al feedback de las compañías
                líderes en el mercado, nuestros clientes.
              </p>
              <p className="mb-4">
                SIDOM Pay es la revolución del comercio exterior a través de su
                botón de pago único, diseñado para transacciones B2B Comex a
                través de un Débito Inteligente desde cualquier cuenta bancaria.
                Este sistema innovador simplifica la oficialización y gestión de
                liquidaciones manuales, transformando la experiencia de pago en
                un proceso automático, eficiente y seguro.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="container mb-4 flex flex-col items-center justify-center ">
        <div>
          <h2 className="text-2xl font-bold mb-8">Beneficios</h2>
        </div>
        <div>
          <Productos productos={productos} />
        </div>
      </div>
      {/* <div className="space-y-8 p-4 lg:p-8">
        <InfoCard
          title="¿Tienes alguna pregunta?"
          description="Nos pondremos en contacto para que puedas saltar al próximo nivel."
          buttonText="Contáctanos"
          buttonLink="/contactus"
          backgroundColor="bg-orange-500"
          iconSrc="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/message.png"
        />
        <InfoCard
          title="Global trade"
          description="La única plataforma 100% Web/SaaS para la gestión punta a punta de la operatoria de importadores y exportadores."
          buttonText="Quiero saber más"
          buttonLink="/"
          backgroundColor="bg-sidom-blue"
          iconSrc="https://sidomsuite.com/wp-content/uploads/2024/09/01.png"
        />
      </div> */}
      <Footer />
      <Switcher />
    </div>
  );
}
